import { Controller } from "@hotwired/stimulus";

// Toggles a password field between masked and plain text, swapping the
// Fomantic eye / eye-slash icon. Expects a `.ui.icon.input` wrapper with an
// `input` target (the password field) and an `icon` target (the clickable eye).
export default class extends Controller {
  static targets = ["input", "icon"];

  toggle(event) {
    // Support activation via click, Enter, or Space (the icon is role="button").
    if (
      event.type === "keydown" &&
      event.key !== "Enter" &&
      event.key !== " "
    ) {
      return;
    }
    event.preventDefault();

    const revealing = this.inputTarget.type === "password";
    this.inputTarget.type = revealing ? "text" : "password";
    // Eye = hidden (click to reveal); eye-slash = visible (click to hide).
    this.iconTarget.classList.toggle("slash", revealing);
    this.iconTarget.setAttribute(
      "aria-label",
      revealing ? "Hide password" : "Show password"
    );
  }
}
